import { Button, HStack, Image, Text, VStack, useColorMode } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import React, { useState } from 'react'
import { FiCalendar, FiChevronDown, FiChevronUp, FiExternalLink } from 'react-icons/fi'
import { getTokens } from '../../config/colorTokens'

const Company = (props) => {
	const { colorMode } = useColorMode()
	const [show, setShow] = useState(false)
	const t = getTokens(colorMode)
	const previewLimit = 120
	const hasDescription = props.description.length > 0
	const firstDescription = hasDescription ? props.description[0] : ''
	const isDescriptionTrimmed = firstDescription.length > previewLimit
	const hasMoreDescription = props.description.length > 1 || isDescriptionTrimmed
	const previewDescription = isDescriptionTrimmed
		? `${firstDescription.substring(0, previewLimit)}...`
		: firstDescription
	const extraDescriptions = props.description.slice(1)
	const descriptionTransition = { duration: 0.28, ease: [0.4, 0, 0.2, 1] }
	const actionButtonStyles = {
		size: 'xs',
		variant: 'ghost',
		bg: 'transparent',
		color: t.accent,
		fontWeight: 'semibold',
		px: 1,
		h: '22px',
		minW: 'fit-content',
		_active: { transform: 'translateY(1px)' },
		_hover: {
			bg: 'transparent',
			color: t.accent,
			textDecoration: 'underline',
			textUnderlineOffset: '3px'
		}
	}

	return (
		<motion.div
			variants={props.variants}
			whileHover={{
				scale: 1.02,
				transition: { type: 'spring', stiffness: 300, damping: 20 }
			}}>
			<VStack
				direction={{ base: 'column', md: 'row' }}
				backdropFilter={'blur(5px)'}
				border="1px"
				borderRadius="10px"
				borderColor={t.borderCard}
				width="100%"
				alignItems={'start'}
				p={4}>
				<HStack alignItems="start">
					<Image
						mt={1}
						style={{ height: '60px', width: '60px' }}
						borderRadius="10px"
						src={props.logo}
					/>
					<VStack alignItems="left" spacing={0} p={0}>
						<Text fontSize="md" fontWeight="bold">
							{props.role}
						</Text>
						<Text fontSize="sm" fontWeight="semibold">
							{props.company} · {props.type}
						</Text>
						<Text color={t.textMuted} fontSize="sm" display="flex" alignItems="center">
							<FiCalendar />
							&nbsp;{props.date}
							{/* &nbsp;· {props.location} */}
						</Text>
						{/* {props.description.length > 0 && !show && <Button variant="link" w="fit-content" size="sm" colorScheme='facebook' _active={{ color: "none" }} onClick={() => setShow(!show)}>{show ? "Hide Details" : "Show Details"}</Button>} */}
					</VStack>
				</HStack>
				{hasDescription && (
					<VStack alignItems={'start'} spacing={1} width="100%">
						<Text fontSize={'sm'}>
							{show ? `• ${firstDescription}` : previewDescription}
							{!show && hasMoreDescription && (
								<Button
									{...actionButtonStyles}
									// ml={2}
									rightIcon={<FiChevronDown />}
									aria-expanded={show}
									onClick={() => setShow(true)}>
									Show More
								</Button>
							)}
						</Text>
						<motion.div
							initial={false}
							animate={{
								maxHeight: show ? 520 : 0,
								opacity: show ? 1 : 0
							}}
							transition={descriptionTransition}
							style={{ overflow: 'hidden', width: '100%' }}>
							<VStack alignItems={'start'} spacing={1}>
								{extraDescriptions.map((d, i) => {
									return (
										<Text fontSize="sm" key={i}>
											• {d}
										</Text>
									)
								})}
							</VStack>
						</motion.div>
					</VStack>
				)}
				<HStack spacing={2} mt={2}>
					{show && hasMoreDescription && (
						<Button
							{...actionButtonStyles}
							w="fit-content"
							leftIcon={<FiChevronUp />}
							aria-expanded={show}
							onClick={() => setShow(false)}>
							Show Less
						</Button>
					)}
					{props.link && (
						<Button
							{...actionButtonStyles}
							w="fit-content"
							rightIcon={<FiExternalLink />}
							onClick={() => window.open(props.link.url, '_blank')}>
							{props.link.text}
						</Button>
					)}
				</HStack>
			</VStack>
		</motion.div>
	)
}

export default Company
